import { createBrowserRouter, redirect } from "react-router-dom";
import Products from "../pages/products";
import Cart from "../pages/cart";
import { ErrorBoundary } from "react-error-boundary";
import ErrorBoundaryFallback from "../components/errorBoundary";
import PaymentSuccess from "../pages/paymentSuccess";
import { baseRouterPath } from "./constants";
import NexisTerms from "../pages/nexisTerms";

export const router = createBrowserRouter([
  {
    path: baseRouterPath,
    element: (
      <ErrorBoundary
        FallbackComponent={ErrorBoundaryFallback}
        onReset={() => redirect(baseRouterPath)}
      >
        <Products />
      </ErrorBoundary>
    ),
  },
  {
    path: `${baseRouterPath}/cart/:sku?`,
    element: (
      <ErrorBoundary
        FallbackComponent={ErrorBoundaryFallback}
        onReset={() => redirect(`${baseRouterPath}/cart`)}
      >
        <Cart />
      </ErrorBoundary>
    ),
  },
  {
    path: `${baseRouterPath}/response/order-confirmation/:orderid`,
    element: (
      <ErrorBoundary
        FallbackComponent={ErrorBoundaryFallback}
        onReset={() => redirect(`${baseRouterPath}/cart`)}
      >
        <PaymentSuccess />
      </ErrorBoundary>
    ),
  },
  {
    path: `${baseRouterPath}/response/failed`,
    element: (
      <ErrorBoundary
        FallbackComponent={ErrorBoundaryFallback}
        onReset={() => redirect(`${baseRouterPath}/cart`)}
      >
        <Cart />
      </ErrorBoundary>
    ),
  },
  {
    path: `${baseRouterPath}/nexis-terms`,
    element: (
      <ErrorBoundary
        FallbackComponent={ErrorBoundaryFallback}
        onReset={() => redirect(`${baseRouterPath}/cart`)}
      >
        <NexisTerms />
      </ErrorBoundary>
    ),
  },
  {
    path: "*",
    element: (
      <ErrorBoundary
        FallbackComponent={ErrorBoundaryFallback}
        onReset={() => redirect(baseRouterPath)}
      >
        <Products />
      </ErrorBoundary>
    ),
  },
]);
